import React from "react";
import SecondaryButton from "./SecondaryButton";
import { ReactComponent as BinIcon } from "../../assets/icons/bin-emotii.svg";
import { TableRow, TableHead } from "./StyledTable"; 

const BulkActionBar = ({ 
  selectedCount, 
  onDelete, 
  onClear,
  actionText = "Delete Selected"
}) => {
  
  if (!selectedCount || selectedCount === 0) return null;

  return (
    <TableRow style={{ gridColumn: "1 / -1", width: "100%" }}>
      <TableHead 
        colSpan={100} 
        style={{ 
          padding: "12px 16px", 
          background: "#F9FAFB", 
          borderBottom: "1px solid #EAECF0", 
          textTransform: "none",
          gridColumn: "1 / -1",
          display: "table-cell",
          width: "100%"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <SecondaryButton
            icon={<BinIcon />}
            text={`${actionText} (${selectedCount})`}
            onClick={onDelete}
            variant="danger"
          />
          <SecondaryButton
            text="Clear Selection"
            onClick={onClear}
            variant="neutral"
          />
        </div>
      </TableHead>
    </TableRow>
  );
};

export default BulkActionBar;